import React, { createElement } from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
// ── Official Meta Pixel (base code) ──────────────────────────────────────────
// Installed at the bootstrap level (not as a React component). Exposes the
// global `fbq` function and fires a single PageView on load. Checkout/purchase
// events (InitiateCheckout, AddPaymentInfo, Purchase) are intentionally NOT
// fired here — those are handled exclusively by Shopify.
!function (f: any, b, e, v, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
// @ts-ignore — fbq is injected by the snippet above
fbq('init', '887021594446000');
// @ts-ignore
fbq('track', 'PageView');
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-237" />);
}